import React, { SVGProps } from 'react';
type SVGRProps = {
  titleId?: string;
};
const SvgIcoMessageBubble = ({ titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    role="img"
    aria-labelledby={titleId}
    {...props}
  >
    <title id={titleId}>MessageBubble</title>
    <path
      d="M25.72 21.567A12.513 12.513 0 0 0 27.57 15c0-6.943-5.628-12.571-12.57-12.571-6.944 0-12.572 5.628-12.572 12.571s5.628 12.572 12.571 12.572c2.305 0 4.465-.62 6.322-1.703l6.821 2.273-2.422-6.573Z"
      stroke="currentColor"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export default SvgIcoMessageBubble;
